import { render, staticRenderFns } from "./DefaultPageToolbar.vue?vue&type=template&id=da3eadd8&scoped=true&"
import script from "./DefaultPageToolbar.vue?vue&type=script&lang=js&"
export * from "./DefaultPageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageToolbar.vue?vue&type=style&index=0&id=da3eadd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3eadd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VPagination,VToolbar})
